import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/security/cwe-lookup/[id]/CWEDetailClient.tsx");
